import * as Sentry from '@sentry/react';

class Logger {
  debug(message: string): void {
    // eslint-disable-next-line no-console
    console.debug(message);
    // Debug messages are not sent to Sentry
  }

  info(message: string): void {
    // eslint-disable-next-line no-console
    console.info(message);
    Sentry.captureMessage(message, 'info');
  }

  warn(message: string): void {
    // eslint-disable-next-line no-console
    console.warn(message);
    Sentry.captureMessage(message, 'warning');
  }

  error(message: string, error?: unknown): void {
    // eslint-disable-next-line no-console
    console.error(message, error);
    if (error) {
      Sentry.captureException(error, {
        tags: {
          logger: true,
        },
        extra: {
          message,
        },
      });
    } else {
      Sentry.captureMessage(message, 'error');
    }
  }

  log(message: string): void {
    // eslint-disable-next-line no-console
    console.log(message);
    Sentry.captureMessage(message, 'info');
  }
}

export default new Logger();
